'use strict';
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var _interopRequireWildcard = require('@babel/runtime/helpers/interopRequireWildcard');
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');
Object.defineProperty(exports, '__esModule', {
    value: true
});
exports.ComponentActionHandler = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require('@babel/runtime/helpers/objectWithoutProperties'));
var _defineProperty2 = _interopRequireDefault(require('@babel/runtime/helpers/defineProperty'));
var R = _interopRequireWildcard(require('ramda'));
var React = _interopRequireWildcard(require('react'));
var _gemsShared = require('@tencent/gems-shared');
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    var _arguments = arguments, _loop = function(i) {
        var source = _arguments[i] != null ? _arguments[i] : {};
        if (i % 2) {
            ownKeys(Object(source), true).forEach(function(key) {
                (0, _defineProperty2.default)(target, key, source[key]);
            });
        } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
            ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
    };
    for(var i = 1; i < arguments.length; i++)_loop(i);
    return target;
}
var LONG_PRESS_TIMEOUT = 1000;
var DOUBLE_CLICK_TIMEOUT = 200;
var INTERSECTION_TIMEOUT = 500;
var ComponentActionHandler = /*#__PURE__*/ function(_PureComponent) {
    _inherits(ComponentActionHandler, _PureComponent);
    var _super = _createSuper(ComponentActionHandler);
    function ComponentActionHandler(props) {
        _classCallCheck(this, ComponentActionHandler);
        var _this;
        _this = _super.call(this, props);
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'intersectionObserver', null);
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'handlerParams', {});
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'handlers', {});
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'containerRef', null);
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'longPressTimer', null);
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'preventClick', false);
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'doubleClickTimer', null);
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'intersectionTimer', null);
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'wrapperStyleCache', []);
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'execActionHooks', function(actions) {
            actions.forEach(function(action) {
                if (typeof action.action.action === 'function') {
                    return;
                }
                var hooks = action.action.action;
                if (hooks !== null && hooks !== void 0 && hooks.afterHandlerRender) {
                    var params = (0, _gemsShared.generateComponentActionParams)(action, _this.props.instance, _this.props.global, _this.props.meta);
                    try {
                        hooks.afterHandlerRender(params);
                    } catch (e) {
                        console.error('Action "afterHandlerRender" hook throw error: ', e);
                    }
                }
            });
        });
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'initIntersectionObserver', function() {
            _this.intersectionObserver = new window.IntersectionObserver(function(entries) {
                entries.forEach(function(param) {
                    var target = param.target, isIntersecting = param.isIntersecting;
                    var key = parseInt(target.getAttribute('data-key'), 10);
                    _gemsShared.events.emit(_gemsShared.EventEmitTypes.COMPONENT_INTERSECTING_CHANGE, isIntersecting, key);
                });
            });
        });
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'observeIntersection', function() {
            return _this.intersectionObserver.observe(_this.containerRef);
        });
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'unobserveIntersection', function() {
            return _this.intersectionObserver.unobserve(_this.containerRef);
        });
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'onComponentIntersectionChange', function(isIntersecting, key) {
            if (key !== _this.props.instance.key) {
                return;
            }
            if (_this.intersectionTimer) {
                clearTimeout(_this.intersectionTimer);
                _this.intersectionTimer = null;
            }
            var callback = isIntersecting ? _this.onComponentEnterView : _this.onComponentLeaveView;
            _this.intersectionTimer = window.setTimeout(function() {
                callback();
                clearTimeout(_this.intersectionTimer);
                _this.intersectionTimer = null;
            }, INTERSECTION_TIMEOUT);
        });
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'onComponentEnterView', function() {
            if (_this.handlers.onEnterView) {
                _this.handlers.onEnterView(undefined);
            }
        });
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'onComponentLeaveView', function() {
            if (_this.handlers.onLeaveView) {
                _this.handlers.onLeaveView(undefined);
            }
        });
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'onComponentPress', (0, _gemsShared.withPersistReactEvent)(function(e) {
            if (e.target === _this.containerRef) {
                return;
            }
            if (!_this.handlers.onLongPress) {
                return;
            }
            _this.longPressTimer = window.setTimeout(function() {
                return _this.handlers.onLongPress(e);
            }, LONG_PRESS_TIMEOUT);
        }));
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'onComponentPressRelease', function(e) {
            if (e.target === _this.containerRef) {
                return;
            }
            if (_this.longPressTimer) {
                window.clearTimeout(_this.longPressTimer);
            }
            _this.longPressTimer = null;
        });
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'onMouseEnter', (0, _gemsShared.withPersistReactEvent)(function(e) {
            if (e.target === _this.containerRef) {
                return;
            }
            _this.handlers.onMouseEnter();
        }));
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'onMouseLeave', (0, _gemsShared.withPersistReactEvent)(function(e) {
            if (e.target === _this.containerRef) {
                return;
            }
            _this.handlers.onMouseLeave();
        }));
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'onSingleClick', (0, _gemsShared.withPersistReactEvent)(function(e1) {
            if (e1.target === _this.containerRef) {
                return;
            }
            _this.doubleClickTimer = window.setTimeout(function() {
                // console.log('click:', this.handlers);
                if (!_this.preventClick) {
                    try {
                        _this.handlers.onClick(e1);
                    } catch (e) {
                        console.error('Exec onClick action error:', e);
                    }
                }
            }, DOUBLE_CLICK_TIMEOUT);
        }));
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'onDoubleClick', (0, _gemsShared.withPersistReactEvent)(function(e) {
            if (e.target === _this.containerRef) {
                return;
            }
            if (_this.doubleClickTimer) {
                clearTimeout(_this.doubleClickTimer);
                _this.doubleClickTimer = null;
            }
            _this.preventClick = true;
            try {
                _this.handlers.onDoubleClick(e);
            } catch (e2) {
                console.error('Exec onClick action error:', e2);
            }
            setTimeout(function() {
                _this.preventClick = false;
            }, DOUBLE_CLICK_TIMEOUT);
        }));
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'emitComponentEvent', function(e, type) {
            var instance = _this.props.instance, _this$handlerParams = _this.handlerParams, global = _this$handlerParams.global, meta = _this$handlerParams.meta;
            return (0, _gemsShared.emitComponent)(e, type, instance, meta, global);
        });
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'withEmitComponentEvent', function(type, handler) {
            return function(e) {
                if (e) {
                    e.persist();
                }
                _this.emitComponentEvent(e, type);
                if (handler) {
                    // console.log('handlerParams', this.handlerParams);
                    return handler(e, _this.handlerParams);
                }
            };
        });
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'updateHandlerParams', function(meta, global) {
            _this.handlerParams.meta = meta;
            _this.handlerParams.global = global;
        });
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'updateHandlersWithParams', function(actions) {
            var _generateHandlers = (0, _gemsShared.generateHandlers)(actions, _this.props.instance), onInit = _generateHandlers.onInit, onClick = _generateHandlers.onClick, onMouseEnter = _generateHandlers.onMouseEnter, onMouseLeave = _generateHandlers.onMouseLeave, onDoubleClick = _generateHandlers.onDoubleClick, onLongPress = _generateHandlers.onLongPress, onEnterView = _generateHandlers.onEnterView, onLeaveView = _generateHandlers.onLeaveView;
            var withEmitComponentEvent = _this.withEmitComponentEvent, handlers = _this.handlers;
            handlers.onInit = withEmitComponentEvent(_gemsShared.ComponentEventListenerTypes.INIT, onInit);
            handlers.onClick = withEmitComponentEvent(_gemsShared.ComponentEventListenerTypes.CLICK, onClick);
            handlers.onMouseEnter = withEmitComponentEvent(_gemsShared.ComponentEventListenerTypes.MOUSE_ENTER, onMouseEnter);
            handlers.onMouseLeave = withEmitComponentEvent(_gemsShared.ComponentEventListenerTypes.MOUSE_LEAVE, onMouseLeave);
            handlers.onDoubleClick = withEmitComponentEvent(_gemsShared.ComponentEventListenerTypes.DOUBLE_CLICK, onDoubleClick);
            handlers.onLongPress = withEmitComponentEvent(_gemsShared.ComponentEventListenerTypes.LONG_PRESS, onLongPress);
            handlers.onEnterView = withEmitComponentEvent(_gemsShared.ComponentEventListenerTypes.ENTER_VIEW, onEnterView);
            handlers.onLeaveView = withEmitComponentEvent(_gemsShared.ComponentEventListenerTypes.LEAVE_VIEW, onLeaveView);
        });
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'setNode', function(node) {
            _this.containerRef = node;
            (0, _gemsShared.setComponentNode)(_this.props.instance.key, node);
        });
        _this.handlerParams = {
            global: props.global,
            meta: props.meta
        };
        _this.updateHandlersWithParams(props.instance.actions);
        return _this;
    }
    _createClass(ComponentActionHandler, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!process.env.isMiniprogram) {
                    this.initIntersectionObserver();
                    this.observeIntersection();
                }
                _gemsShared.events.on(_gemsShared.EventEmitTypes.COMPONENT_INTERSECTING_CHANGE, this.onComponentIntersectionChange);
                if (this.handlers.onInit) {
                    this.handlers.onInit(undefined);
                }
                this.execActionHooks(this.props.instance.actions);
            }
        },
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                if (nextProps.global !== this.props.global || nextProps.meta !== this.props.meta) {
                    this.updateHandlerParams(nextProps.meta, nextProps.global);
                }
                if (nextProps.instance.actions !== this.props.instance.actions) {
                    this.updateHandlersWithParams(nextProps.instance.actions);
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (!process.env.isMiniprogram) {
                    this.unobserveIntersection();
                }
                _gemsShared.events.cancel(_gemsShared.EventEmitTypes.COMPONENT_INTERSECTING_CHANGE, this.onComponentIntersectionChange);
                (0, _gemsShared.deleteComponentNode)(this.props.instance.key);
                if (this.longPressTimer) {
                    window.clearTimeout(this.longPressTimer);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, children = _this$props.children, rest = (0, _objectWithoutProperties2.default)(_this$props, [
                    'children'
                ]);
                var wrapperStyle = rest.instance.wrapperStyle;
                var isContainer = rest.instance.component.isContainer;
                delete rest.instance;
                delete rest.meta;
                delete rest.global;
                var elementType = process.env.isMiniprogram ? 'wx-button' : 'div'; // wx-button 视为 Web Components, 故使用 class, 见 https://reactjs.org/docs/dom-elements.html#classname
                var classKey = process.env.isMiniprogram ? 'class' : 'className';
                var _obj;
                return(/*#__PURE__*/ React.createElement(elementType, (_obj = {}, _defineProperty(_obj, classKey, '__impage-component-actions-proxy'), _defineProperty(_obj, "id", (0, _gemsShared.getComponentId)(this.props.instance.key)), _defineProperty(_obj, "style", isContainer ? _objectSpread(_objectSpread({}, wrapperStyle), {}, {
                    position: 'relative'
                }) : wrapperStyle), _defineProperty(_obj, "ref", this.setNode), _defineProperty(_obj, 'data-key', this.props.instance.key), _defineProperty(_obj, "onClick", this.onSingleClick), _defineProperty(_obj, "onDoubleClick", this.onDoubleClick), _defineProperty(_obj, "onMouseEnter", this.onMouseEnter), _defineProperty(_obj, "onMouseLeave", this.onMouseLeave), _defineProperty(_obj, "onTouchStart", this.onComponentPress), _defineProperty(_obj, "onTouchEnd", this.onComponentPressRelease), _defineProperty(_obj, "onMouseDown", this.onComponentPress), _defineProperty(_obj, "onMouseUp", this.onComponentPressRelease), _obj), R.isEmpty(rest) ? children : React.Children.map(children, function(child) {
                    /*#__PURE__*/ return React.cloneElement(child, rest);
                })));
            }
        }
    ]);
    return ComponentActionHandler;
}(React.PureComponent);
exports.ComponentActionHandler = ComponentActionHandler;
